import React, { Component } from 'react';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

import Cookies from 'universal-cookie';
import axios from 'axios';



import Navbar from './../Component/Navbar';
import Next from './../../Next';
import swal from 'sweetalert';
import { Redirect } from 'react-router';

class Register extends Component {
    constructor(props){
        super(props);
        document.title = "Đăng ký";
        const cookies = new Cookies();

        cookies.remove("token");

        this.ChangeUsername = this.ChangeUsername.bind(this);
        this.ChangePassword = this.ChangePassword.bind(this);
        this.ChangeRepassword = this.ChangeRepassword.bind(this);
        this.Dangky = this.Dangky.bind(this);
        this.state = {
            'username': '',
            'password': '',
            'repassword': '',
            'load': false,
            'regsuccess': false,
        }
    }

    ChangeUsername(event){
        this.setState({username: event.target.value});
    }

    ChangePassword(event){
        this.setState({password: event.target.value});
    }

    ChangeRepassword(event){
        this.setState({repassword: event.target.value});
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }    


    Dangky(event) {
        this.setState({load: true});

        var url = 'dang-ky.php';        
        var data = {
            'username': this.state.username,
            'password': this.state.password,
            'repassword': this.state.repassword,
        };

        const cookies = new Cookies();
    
        var token = 'null'
    
        if ( !cookies.get('token') ) {
            token = 'null'
        } else {
            token = cookies.get('token');
        };
        
        const headers = { Authorization: `${token}` };
    
        axios.post (process.env.REACT_APP_API + url, data, { headers } )
        .then(response => {
          this.setState({load: false});

          var content = response.data;

          if (content.status == true){
              var type = 'success';
              var token = content.data.token;
              cookies.set('token', token); 
              swal("Thông báo", content.message, type);
              this.sleep(1000).then(() => { 
                this.setState({regsuccess: true});
               });
          } else {
              var type = 'error';
              cookies.set('token', ''); 
              swal("Thông báo", content.message, type);
          }

        })
        .catch(error => console.log(error));
        

        event.preventDefault();
    }

    render() {
        var noload = <button type="submit" className="btn btn-danger w-100pt">Đăng ký</button>;
        var haveload = <button type="submit" className="btn btn-danger w-100pt" disabled> 
            Đăng ký  
            <span className="px-1"></span>   
            <div className="spinner-border spinner-border-sm" role="status">
                <span className="sr-only"></span>
            </div>
        </button>;
        
        return (
            <div>
                {this.state.regsuccess ? <Redirect to="/" />  :  ''}
                <Navbar />

                <div className="py-5"></div>
                <div className="py-5"></div>

                <div className="container">
                    <div className="bg-main py-4 rounded container">
                        <form onSubmit={this.Dangky}>

                            <label>Tài khoản:</label>
                            <input className="form-control rounded-pill inputx mb-4" placeholder="Nhập tài khoản" value={this.state.username} onChange={this.ChangeUsername}></input>

                            <label>Mật khẩu:</label>
                            <input className="form-control rounded-pill inputx mb-4" type="password" placeholder="Nhập mật khẩu" value={this.state.password} onChange={this.ChangePassword}></input>

                            <label>Nhập lại mật khẩu:</label>
                            <input className="form-control rounded-pill inputx mb-4" type="password" placeholder="Nhập lại mật khẩu" value={this.state.repassword} onChange={this.ChangeRepassword}></input>

                            {this.state.load ? haveload  :  noload}

                            <div className="py-3"></div>

                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default Register;